var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDone({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_750_13010)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7884 26.5385C16.5377 26.5385 16.5557 26.2192 15.5048 25.1683C14.9365 24.5999 14.4385 24.102 13.8702 23.5337C13.3178 22.9813 12.836 22.4995 12.2837 21.9471C11.7998 21.4632 10.1766 20.275 11.3692 18.9654C13.1341 17.0273 15.2798 21.3979 17.5 22.8846C17.9726 22.7584 21.9989 18.53 22.4279 18.101L26.0337 14.4952C26.8403 13.6885 26.8293 13.4615 27.8846 13.4615C28.6104 13.4615 29.0385 14.0746 29.0385 14.9038C29.0385 16.0727 27.5281 16.8041 26.5242 18.0626C25.7864 18.9874 21.9832 22.6821 20.8413 23.8221C20.1753 24.4871 18.5522 26.5385 17.7884 26.5385ZM0 19.2308C0 22.8405 0.392872 25.5139 1.89092 28.4937C2.17482 29.0584 2.39353 29.5577 2.70969 30.0788C3.02557 30.5994 3.31768 31.0624 3.65408 31.5382L5.83744 34.1626C6.08104 34.4062 6.21458 34.4406 6.46824 34.6856C6.72653 34.935 6.83851 35.0762 7.11453 35.2893C7.56401 35.6363 7.99511 36.0164 8.46178 36.3459C11.2597 38.3213 15.4089 40 19.2308 40C23.3996 40 24.8635 39.6017 28.421 38.1325C29.0042 37.8916 29.4863 37.594 29.9952 37.3029C32.9333 35.6223 35.5115 32.9605 37.2685 30.057C37.4486 29.7595 37.5337 29.5404 37.7109 29.2493C39.0148 27.108 40 23.0967 40 20.5769C40 17.0591 39.5336 14.3397 38.1091 11.5063C37.0075 9.31518 36.2933 8.19107 34.7345 6.51552C33.9297 5.65053 34.5833 6.23613 33.5344 5.31176C32.0507 4.00422 31.9106 3.82105 30.0788 2.70969C27.7533 1.29882 23.9545 0 20.7692 0C17.0089 0 14.6581 0.381898 11.4739 1.85847C7.35969 3.76629 3.76629 7.35969 1.85847 11.4739C0.954054 13.4243 0 16.4385 0 19.2308Z",
    fill: "#FE8016"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_750_13010"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDone);
export default __webpack_public_path__ + "static/media/done.59088a043c8bc2f7ce063b475b584863.svg";
export { ForwardRef as ReactComponent };